module.exports = __webpack_public_path__ + "img/video.a1ba18ea.png";